module.exports = __webpack_public_path__ + "static/father-carrying-daughter-on-shoulders.061c8556.webp";